module.exports = __webpack_public_path__ + "img/gen_metal16.edb99097.png";